import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-hsa-investment-modal',
  templateUrl: './hsa-investment-modal.component.html',
  styleUrls: ['./hsa-investment-modal.component.scss']
})
export class HsaInvestmentModalComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<HsaInvestmentModalComponent>) { }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }
}
